"use strict";

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = arguments;
  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

module.exports = createChainedFunction;


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-calendar/~/rc-util/lib/createChainedFunction.js
 ** module id = 540
 ** module chunks = 0
 **/